(function () {
  'use strict';

  const FLASH_MS = 450;
  const EXIT_MS = 650;
  const STORAGE_KEY = 'glassyDiscountJustApplied';
  const CONFETTI_COLORS = ['#ffd700', '#ffed4e', '#ff8c00', '#00ff88', '#00c853', '#ffffff'];
  const CONFETTI_PIECES = 80;

  document.addEventListener('click', function (event) {
    const link = event.target.closest('.secret-discount-button');
    if (!link) return;

    if (link.dataset.secretDiscountBusy === 'true') {
      event.preventDefault();
      return;
    }

    // Unified flow: always intercept and apply in-place, whether the click came
    // from the mini-cart drawer or the main /cart page. Navigation is only a
    // fallback if the in-place flow throws.
    event.preventDefault();
    link.dataset.secretDiscountBusy = 'true';

    // Persist the intent immediately. Even if a network hiccup forces the
    // navigation fallback below, the post-redirect page will see this flag
    // (via the inline head script) and the button will stay hidden.
    try { localStorage.setItem('glassyDiscountApplied', '1'); } catch (e) {}

    link.classList.add('secret-discount-button--flashing');
    window.setTimeout(function () {
      link.classList.remove('secret-discount-button--flashing');
    }, FLASH_MS);

    applyDiscountInPlace(link).catch(function (err) {
      console.error('[secret-discount] in-place apply failed, falling back to navigation:', err);
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      window.location.href = link.getAttribute('href');
    });
  });

  async function applyDiscountInPlace(link) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const codeMatch = link.getAttribute('href').match(/discount\/([^?\/]+)/);
    const code = codeMatch && codeMatch[1];
    if (!code) throw new Error('Could not parse discount code from link');

    const discountResponse = await fetch(root + 'discount/' + encodeURIComponent(code), {
      credentials: 'same-origin'
    });
    if (!discountResponse.ok && discountResponse.status !== 0) {
      throw new Error('Discount endpoint returned ' + discountResponse.status);
    }

    const cartResponse = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!cartResponse.ok) throw new Error('cart.js returned ' + cartResponse.status);
    const cart = await cartResponse.json();

    // Snapshot the button's screen position BEFORE we mutate any styles,
    // so confetti emits from where the user actually clicked.
    const buttonRect = link.getBoundingClientRect();
    const inDrawer = !!link.closest('cart-drawer');

    // Always fire confetti when the apply flow reaches this point — the user
    // clicked and the network round-trip succeeded.
    launchConfetti(buttonRect);

    // Animate every visible secret-discount-button out smoothly.
    document.querySelectorAll('.secret-discount-button').forEach(animateButtonExit);

    // After the exit animation, lock all .secret-discount-buttons via a class
    // on <html>, then trigger the appropriate refresh path. The class survives
    // any innerHTML swap because it lives on the parent.
    window.setTimeout(function () {
      document.documentElement.classList.add('glassy-discount-applying');

      if (inDrawer) {
        // Mini-cart: Focal's CartDrawer._rerenderCart handler picks this up
        // and re-renders the drawer with the updated discount + total.
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })
        );
      }
      // Main /cart page: do nothing else. The CSS class lock keeps the gold
      // button hidden, the discount cookie is set on the server, and Shopify's
      // checkout will apply the discount. The cart totals stay exactly as they
      // were rendered — no in-place updates, no jarring innerHTML swaps.
    }, EXIT_MS);
  }

  function animateButtonExit(link) {
    const height = link.offsetHeight;
    const computed = window.getComputedStyle(link);

    // Lock in current dimensions so the transition has something to interpolate
    // from when we collapse to zero.
    link.style.maxHeight = height + 'px';
    link.style.marginTop = computed.marginTop;
    link.style.marginBottom = computed.marginBottom;
    link.style.paddingTop = computed.paddingTop;
    link.style.paddingBottom = computed.paddingBottom;
    link.style.overflow = 'hidden';
    link.style.pointerEvents = 'none';

    // Force a reflow so the locked-in values are committed before transition.
    void link.offsetHeight;

    link.style.transition =
      'max-height ' + EXIT_MS + 'ms cubic-bezier(0.55, 0.06, 0.68, 0.19), ' +
      'margin ' + EXIT_MS + 'ms cubic-bezier(0.55, 0.06, 0.68, 0.19), ' +
      'padding ' + EXIT_MS + 'ms cubic-bezier(0.55, 0.06, 0.68, 0.19), ' +
      'opacity ' + (EXIT_MS - 100) + 'ms ease-out, ' +
      'transform ' + EXIT_MS + 'ms cubic-bezier(0.55, 0.06, 0.68, 0.19), ' +
      'border-width ' + EXIT_MS + 'ms ease-out';

    link.style.maxHeight = '0px';
    link.style.marginTop = '0px';
    link.style.marginBottom = '0px';
    link.style.paddingTop = '0px';
    link.style.paddingBottom = '0px';
    link.style.opacity = '0';
    link.style.transform = 'scale(0.92) translateY(-6px)';
    link.style.borderWidth = '0px';
  }

  function getConfettiLayer() {
    let layer = document.getElementById('secret-discount-confetti-layer');
    if (!layer) {
      layer = document.createElement('div');
      layer.id = 'secret-discount-confetti-layer';
      // Always re-append to body so we're the LAST element in <body>,
      // winning the stacking-order battle against drawers/overlays.
      document.body.appendChild(layer);
    } else {
      // Re-append to make sure we're still on top even if other overlays
      // were inserted after our last burst.
      document.body.appendChild(layer);
    }
    return layer;
  }

  function launchConfetti(originRect) {
    if (!originRect) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const originX = originRect.left + originRect.width / 2;
    const originY = originRect.top + originRect.height / 2;
    const layer = getConfettiLayer();

    for (let i = 0; i < CONFETTI_PIECES; i++) {
      const piece = document.createElement('div');
      piece.className = 'secret-discount-confetti-piece';

      piece.style.background = CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)];
      piece.style.left = originX + 'px';
      piece.style.top = originY + 'px';

      if (Math.random() > 0.55) {
        piece.style.width = '9px';
        piece.style.height = '9px';
        piece.style.borderRadius = '50%';
      } else {
        piece.style.width = '7px';
        piece.style.height = '13px';
        piece.style.borderRadius = '2px';
      }

      layer.appendChild(piece);

      const angle = Math.random() * Math.PI * 2;
      const burstDistance = 100 + Math.random() * 240;
      const burstX = Math.cos(angle) * burstDistance;
      const burstY = Math.sin(angle) * burstDistance - 90 - Math.random() * 150;
      const finalX = burstX + (Math.random() - 0.5) * 240;
      const finalY = window.innerHeight - originY + 140;
      const rotation = (Math.random() - 0.5) * 1080;
      const duration = 1700 + Math.random() * 1100;

      const anim = piece.animate(
        [
          { transform: 'translate3d(-50%, -50%, 0) rotate(0deg)', opacity: 1 },
          {
            transform: 'translate3d(calc(-50% + ' + burstX + 'px), calc(-50% + ' + burstY + 'px), 0) rotate(' + (rotation * 0.4) + 'deg)',
            opacity: 1,
            offset: 0.32
          },
          {
            transform: 'translate3d(calc(-50% + ' + finalX + 'px), calc(-50% + ' + finalY + 'px), 0) rotate(' + rotation + 'deg)',
            opacity: 0
          }
        ],
        {
          duration: duration,
          easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
          fill: 'forwards'
        }
      );

      anim.onfinish = function () { piece.remove(); };
    }
  }

  function checkForPendingCelebration() {
    let justApplied = false;
    try {
      justApplied = sessionStorage.getItem(STORAGE_KEY) === '1';
      if (justApplied) sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}

    if (!justApplied) return;
    if (document.querySelector('.secret-discount-button')) return;

    const anchor = document.querySelector(
      '.cart__total-container, .cart__discount-list, .cart__discount, .cart__recap'
    );
    const rect = anchor
      ? anchor.getBoundingClientRect()
      : {
          left: window.innerWidth / 2 - 50,
          top: window.innerHeight / 4,
          width: 100,
          height: 50
        };

    launchConfetti(rect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkForPendingCelebration);
    document.addEventListener('DOMContentLoaded', selfCorrectAppliedFlag);
  } else {
    checkForPendingCelebration();
    selfCorrectAppliedFlag();
  }

  // If the localStorage flag is set but /cart.js shows no discount actually
  // applied (e.g. code was disabled in admin, hit usage limit, cart was emptied,
  // or the click never made it through), clear the flag + class so the button
  // can reappear. Keeps the "remember" state honest.
  async function selfCorrectAppliedFlag() {
    let flagSet = false;
    try { flagSet = localStorage.getItem('glassyDiscountApplied') === '1'; } catch (e) {}
    if (!flagSet) return;

    try {
      const cart = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json(); });

      const hasDiscount =
        (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) ||
        (cart.discount_codes && cart.discount_codes.length > 0) ||
        (cart.original_total_price > cart.total_price);

      if (!hasDiscount) {
        try { localStorage.removeItem('glassyDiscountApplied'); } catch (e) {}
        document.documentElement.classList.remove('glassy-discount-applying');
      }
    } catch (e) {
      // Network failure — leave the flag in place; better to over-hide than over-show.
    }
  }

  // ---- Countdown timer ("Offer ends in HH:MM:SS", resets at midnight PT) ----

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function millisUntilMidnightPT() {
    const now = new Date();
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(now);

    let hour = 0, minute = 0, second = 0;
    for (const part of parts) {
      if (part.type === 'hour') hour = parseInt(part.value, 10);
      if (part.type === 'minute') minute = parseInt(part.value, 10);
      if (part.type === 'second') second = parseInt(part.value, 10);
    }
    // Intl can return "24" for midnight in some locales; normalize.
    if (hour === 24) hour = 0;

    const elapsedSec = hour * 3600 + minute * 60 + second;
    const remainingSec = 24 * 3600 - elapsedSec;
    return remainingSec * 1000;
  }

  function tickCountdown() {
    const targets = document.querySelectorAll('[data-secret-discount-countdown]');
    if (!targets.length) return;
    const totalSec = Math.max(0, Math.floor(millisUntilMidnightPT() / 1000));
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    const formatted = pad(h) + ':' + pad(m) + ':' + pad(s);
    targets.forEach(function (el) { el.textContent = formatted; });
  }

  tickCountdown();
  window.setInterval(tickCountdown, 1000);

  // ---- Product-page price callout: keep in sync with the selected variant ----

  function formatMoneyLocal(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const fmt = (window.themeVariables && window.themeVariables.shop && window.themeVariables.shop.moneyFormat) || '${{amount}}';
      try { return window.Shopify.formatMoney(cents, fmt); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  document.addEventListener('variant:changed', function (event) {
    const variant = event && event.detail && event.detail.variant;
    if (!variant || typeof variant.price !== 'number') return;
    const discounted = Math.round(variant.price * 0.7);
    document.querySelectorAll('[data-secret-discount-discounted-price]').forEach(function (el) {
      el.textContent = formatMoneyLocal(discounted);
    });
  });
})();
